import { type PortalFeatureFlagRegistry, definePortalFeatureFlag } from './featureFlagDefinition';

export const PortalFeatureFlags = {
  // Datadog flags
  menuV3_enableQa: definePortalFeatureFlag('datadog', 'menuV3_enableQa', 'boolean'),
  menuV3_externalIdInvalidator: definePortalFeatureFlag(
    'datadog',
    'menuV3_externalIdInvalidator',
    'boolean'
  ),

  // Harness flags
  sampleHarnessFlag: definePortalFeatureFlag('harness', 'sampleHarnessFlag', 'boolean'),
  accessEntitlementsV2Page: definePortalFeatureFlag(
    'harness',
    'accessEntitlementsV2Page',
    'boolean'
  ),
  liveOverviewReportHomepage: definePortalFeatureFlag(
    'harness',
    'liveOverviewReportHomepage',
    'boolean'
  ),

  // Org-keyed Harness flags (traffic type org_id, targetingKey = orgId).
  // See docs/005-org-keyed-feature-flag-evaluation-for-harness-split-segments.md.
  showMenuListingV3Org: definePortalFeatureFlag(
    'harnessWithOrgIdTargetingKey',
    'showMenuListingV3Org',
    'boolean'
  ),
  menuV3_enableEmptyNameValidation: definePortalFeatureFlag(
    'harnessWithOrgIdTargetingKey',
    'menuV3_enableEmptyNameValidation',
    'boolean'
  ),
  menuV3_enableMobileMenuEditor: definePortalFeatureFlag(
    'harnessWithOrgIdTargetingKey',
    'menuV3_enableMobileMenuEditor',
    'boolean'
  ),
  flipdishAssistant: definePortalFeatureFlag('harness', 'flipdishAssistant', 'boolean'),
  aiMarketing: definePortalFeatureFlag('harness', 'aiMarketing', 'boolean'),
} as const satisfies PortalFeatureFlagRegistry;
